var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFolderCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 14L23.7689 9.53783C23.1268 8.25361 22.8057 7.61146 22.3267 7.14233C21.9032 6.72746 21.3926 6.41195 20.8321 6.21862C20.1983 6 19.4804 6 18.0446 6H10.4C8.15979 6 7.03969 6 6.18404 6.43597C5.43139 6.81947 4.81947 7.43139 4.43597 8.18404C4 9.03969 4 10.1598 4 12.4V14M4 14H34.4C37.7603 14 39.4405 14 40.7239 14.654C41.8529 15.2292 42.7708 16.1471 43.346 17.2761C44 18.5595 44 20.2397 44 23.6V32.4C44 35.7603 44 37.4405 43.346 38.7239C42.7708 39.8529 41.8529 40.7708 40.7239 41.346C39.4405 42 37.7603 42 34.4 42H13.6C10.2397 42 8.55953 42 7.27606 41.346C6.14708 40.7708 5.2292 39.8529 4.65396 38.7239C4 37.4405 4 35.7603 4 32.4V14ZM18 28L22 32L31 23",
    stroke: "#394049",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderCheck);
export default __webpack_public_path__ + "static/media/folder-check.ed10e5f44ec86f22fe8ada0321d5dd98.svg";
export { ForwardRef as ReactComponent };